Vue.filter('time', function (value) {
  if (!value && value.format()) return '';
  return `${value.format('HH:mm')}h`;
})
